
<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
    <!-- <sidebar class="sidebar-container" /> -->
    <div class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
      </div>

      <rightNavBar class="fixed-right" />
      <app-main />
     
      <div class="btm-box">
        <div class="top">
          <div class="logo-box row-between">
            <img src="../assets/images/btm-LOGO.png" alt="" />

            <div class="row-between flex1 btn-box">
              <el-button
                class="black-c"
                :class="{ 'active-btm-btn': btmCurrent === index }"
                type="text"
                v-for="(item, index) in btmBtnArr"
                :key="index"
                @click="btmBtnClick(index)"
                >{{ item }}</el-button
              >
            </div>
          </div>

          <div class="row-end info-box">
            <div>
              <div class="c-666 fs-14">{{ sysInfo[0].address }}</div>
              <div class="text-right c-phone mt10">
                {{ sysInfo[0].phonenumber }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="btm row-center fs-14">{{ sysInfo[0].systemIcp }}</div> -->
        <div class="btm row-center fs-14 footer">
          {{ sysInfo[0].systemIcp }}
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            style="margin-left: 7px"
            >粤ICP备2023013564号-1</a
          >
          <a
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302002351"
            target="_blank"
            style="margin-left: 7px"
          >
            <img src="@/assets/images/gov.png" alt="" />
            粤公网安备 44030302002351号</a
          >
        </div>
      </div>
    </div>

    <!-- 意见反馈表单 -->
    <feedback :is-show="dialogShow" @close="dialogShow = false" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "./mixin/ResizeHandler";
import rightNavBar from "@/components/rightNavBar";
import feedback from "@/components/dialog/feedback";
import { Navbar, Sidebar, AppMain } from "./components";


export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    rightNavBar,
    feedback,
  },
  mixins: [ResizeMixin],
  data() {
    return {
      btmBtnArr: [
        "关于我们",
        "联系我们",
        "加入我们",
        "会员权益",
        "意见反馈",
        "网站声明",
      ],
      btmCurrent: "",
      baseUrl: process.env.VUE_APP_BASE_API,
      // 意见反馈表单是否显示
      dialogShow: false,
    };
  },
  computed: {
    ...mapGetters(["sysInfo"]),
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  created() {},
  methods: {
  
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    // 底部按钮点击
    btmBtnClick(idx) {
      this.btmCurrent = idx;
      // 关于我们
      if (idx === 0) {
        this.$router.push({
          path: "/aboutInfo/index",
          query: { type: "aboutUs", fakeVal: Math.random() },
        });
      }
      // 联系我们
      if (idx === 1) {
        this.$router.push({
          path: "/aboutInfo/index",
          query: { type: "relation", fakeVal: Math.random() },
        });
      }
      // 加入我们
      if (idx === 2) {
        this.$router.push({
          path: "/aboutInfo/index",
          query: { type: "join", fakeVal: Math.random() },
        });
      }
      // 会员权益
      if (idx == 3) {
        this.$router.push("/interests/index");
      }
      // 意见反馈
      if (idx == 4) {
        this.dialogShow = true;
      }
      // 网站声明
      if (idx === 5) {
        this.$router.push({
          path: "/aboutInfo/index",
          query: { type: "websiteUs", fakeVal: Math.random() },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.footer img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
}

.ql-container {
  height: 500px;
}

.black-c {
  color: black;
}

.active-btm-btn {
  color: #1d6faf;
}

.btm-box {
  width: 100%;
  background: #fff;

  margin-top: 70px;

  .logo-box {
    padding-bottom: 15px;
    border-bottom: 1px solid #ddd;
  }

  .info-box {
    box-sizing: border-box;
    padding: 50px 0 40px;

    .c-666 {
      color: #666;
    }

    .c-phone {
      color: #20a3dd;
    }
  }

  .top {
    padding-top: 40px;
    padding-bottom: 15px;
    padding-left: 15vw;
    padding-right: 15vw;

    .btn-box {
      margin-left: 20vw;
    }

    .search-box {
      width: 330px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #ddd;
      overflow: hidden;

      ::v-deep .el-input__inner {
        border: none;
      }

      .mail-btn {
        border-radius: 20px;
        background: #000;
        color: #fff;
      }
    }
  }

  .btm {
    width: 100%;
    height: 60px;
    background: #1d6faf;
    color: #fff;
    font-family: PingFang SC;
  }
}

.fixed-right {
  position: fixed;
  right: 100px;
  top: 200px;
  z-index: 20;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
